import React, { useContext } from "react";
import type { FeatureAppDependencies } from "../featureapp";

export const FeatureAppContext = React.createContext<{ isFeatureApp: boolean }>({ isFeatureApp: false });
export const FeatureServicesContext = React.createContext<{ services?: FeatureAppDependencies }>({});

export function useServices(): FeatureAppDependencies {
    return useContext(FeatureServicesContext).services!;
}
